import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<nb-bottom-nav>` — the mobile bottom navigation bar (Mockup `.bottomnav`).
 *
 * A fixed-height bar that sits at the bottom of a mobile shell. Project
 * `<nb-bottom-nav-item>`s and an optional centred `<nb-bottom-nav-fab>`.
 * Exposes a `navigation` landmark with an accessible name so AT users can
 * jump to it; honours the iOS home-indicator safe area via the bottom inset.
 *
 * @example
 * <nb-bottom-nav>
 *   <nb-bottom-nav-item label="Hjem" [active]="true"><nb-icon [icon]="Home"/></nb-bottom-nav-item>
 *   <nb-bottom-nav-item label="Varsler" [count]="3"><nb-icon [icon]="Bell"/></nb-bottom-nav-item>
 *   <nb-bottom-nav-fab (action)="create()" />
 *   <nb-bottom-nav-item label="Kart"><nb-icon [icon]="Map"/></nb-bottom-nav-item>
 *   <nb-bottom-nav-item label="Profil"><nb-icon [icon]="User"/></nb-bottom-nav-item>
 * </nb-bottom-nav>
 */
@Component({
  selector: 'nb-bottom-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'navigation',
    'aria-label': 'Hovednavigasjon',
  },
  template: `<ng-content />`,
  styleUrl: './bottom-nav.css',
})
export class NbBottomNav {}
